module.exports = require('./lib/gigya');
